<template>
  <div class="container" style="background-color: #212c4f;">
    <div class="login">
      <h1>
        <span class="faded_h1">li</span>Sync<span class="faded_h1">e</span
        ><span class="green_h1">.</span>
      </h1>
      <h4 style="margin-top: 10px;">Sign in For Sync Licensing</h4>
      <input type="email" name="email" v-model="email" placeholder="Email" />
      <input
        type="password"
        name="password"
        v-model="password"
        placeholder="Password"
      />
      <button @click.prevent="submit" :disabled="isLoading">
        <div v-if="isLoading">
          <!-- Loader Icon or Animation -->
          <svg aria-hidden="true" class="inline w-5 h-5 text-gray-400 animate-spin dark:text-gray-500 fill-gray-900 dark:fill-gray-900" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
        </div>
        <div v-else>Sign In</div>
      </button>
      <div class="request">
        Don't have a liSynce account?
        <router-link to="/request">Create Account</router-link>
      </div>
      <router-link to="/recover">Forgot your password?</router-link>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { useStore } from 'vuex';

export default {
  name: "SignIn",
  setup() {
    const email = ref("");
    const isLoading = ref(false);
    const password = ref("");
    const router = useRouter();
    const store = useStore(); // Use Vuex store
    const submit = async () => {
      isLoading.value = true;
      const response = await axios.post("account/lisynce/login", {
        username: email.value,
        pword: password.value,
      });
      if (response.data.status == 'success') {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("organization_ids", JSON.stringify(response.data.organization_ids));
        localStorage.setItem("userId", response.data.user_id);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("isFuneralHome", response.data.isFuneralHome);
        console.log(response);
        isLoading.value = false;
        // await router.push({ path: "/" });
        await router.push("/").then(() => {
          // Refresh the page after navigation
          location.reload();
        });
      } else if (response.data.registrationstatus && response.data.funeral_form) {
          handleStatusAndRedirect(response.data.registrationstatus, response.data.funeral_form);
          isLoading.value = false;
      } else {
        isLoading.value = false;
        alert(response.data.message)
      }
      isLoading.value = false;
    };

    const handleStatusAndRedirect = async (status, funeralForm) => {
      store.dispatch('updateFuneralForm', funeralForm); // Save funeral form in Vuex

      if (status === 'SIGNED_UP') {
        try {
          const agreementResponse = await axios.post(
            `${axios.defaults.baseURL}account/lisynce/createAgreement`,
            funeralForm,
            { responseType: 'blob' }
          );
          const url = URL.createObjectURL(new Blob([agreementResponse.data], { type: 'application/pdf' }));
          store.dispatch('updateDocument', url); // Save document in Vuex
          isLoading.value = false;
          await router.push({ name: 'FuneralAgreement' });
        } catch (error) {
          console.error('Error retrieving agreement:', error);
          isLoading.value = false;
          alert('An error occurred while creating the agreement. Please try again.');
        }
      } else if (status === 'AGREEMENT_SIGNED') {
        isLoading.value = false;
        await router.push({ name: 'CreditCardForm' }); // Redirect to CreditCardForm
      } else {
        isLoading.value = false;
        alert("Invalid status. Please contact support.");
      }
    };
    return {
      email,
      password,
      isLoading,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/global-styles/colors.scss";
@import "@/global-styles/typography.scss";
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: 0 auto;
}
.login {
  width: 400px;
}

.request {
  // position: absolute;
  // top: 40px;
  // right: 40px;
  color: rgba(255, 255, 255, 0.3);

  a {
    color: white;
  }
}

.faded_h1 {
  @include heading-1(rgba(255, 255, 255, 0.5));
}

.green_h1 {
  @include heading-1($green);
}

h4 {
  margin: 0;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  color: #ffffff;
}

input {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  height: 60px;
  width: 100%;

  font-size: 20px;
  color: white;
  padding-left: 20px;
  margin-top: 20px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }
}

button {
  background: #86bc25;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border: none;
  margin-top: 20px;

  height: 60px;
  width: 100%;

  font-size: 20px;
  color: white;
  margin-bottom: 40px;
}

a {
  font-size: 16px;
  line-height: 25px;
  /* identical to box height */

  text-align: center;

  color: rgba(255, 255, 255, 0.3);
  text-decoration: none;
}
</style>
